module.exports = __webpack_public_path__ + "img/machineLearning.d4990d00.svg";